var map = {
	"./app/activity.png": "SoK4",
	"./app/appointment.png": "89du",
	"./app/article.png": "0dq+",
	"./app/baidu.png": "afEE",
	"./app/closure.png": "och2",
	"./app/company.png": "ViOo",
	"./app/house.png": "Zg/r",
	"./app/msg.png": "RBF1",
	"./app/pay.png": "w5zi",
	"./app/poster.png": "oAV5",
	"./app/present.png": "tHlv",
	"./audio.png": "piFs",
	"./cert.png": "mxBT",
	"./commonIcon/assemble.png": "OSt1",
	"./commonIcon/businessCard.png": "BKIj",
	"./commonIcon/company.png": "pEIT",
	"./commonIcon/customer.png": "j28u",
	"./commonIcon/dynamic.png": "rBJ+",
	"./commonIcon/goods.png": "3q0v",
	"./commonIcon/website.png": "nLPQ",
	"./diy/banner-tongping.png": "VodW",
	"./file.png": "N6hI",
	"./icon/1.png": "tbYh",
	"./icon/2.png": "ihEB",
	"./icon/3.png": "twuN",
	"./icon/apps.png": "RD+4",
	"./logo.png": "7Otq",
	"./logo2.png": "xAza",
	"./nav-bg.png": "lzON",
	"./video.png": "wa1j",
	"./wxuploadkey.png": "rU2+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "32Qh";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.png$
// module id = 32Qh
// module chunks = 160